import React from 'react';

import { PRODUCT_BLOCK_TYPES, useProductBlock } from '../helpers/useProductBlock';
import ProductGrid from './product-grid';
import { SectionWithProductGridContent } from './types';

/**
 * V2 `section_with_product_grid` (SERVER PATH): a two-column product grid in the article column. Both
 * `grid_type`s share one view; only the products and the tile layout differ (see useProductBlock). The
 * hits were preloaded server-side, so there is deliberately no client (InstantSearch) fallback.
 */
export default function SectionWithProductGrid({ content }: { content: SectionWithProductGridContent }) {
  const { products, tileLayout } = useProductBlock('grid', content?.grid_type, content);

  if (!PRODUCT_BLOCK_TYPES.includes(content?.grid_type)) {
    console.error(`SectionWithProductGrid: unknown grid_type "${content?.grid_type}"`);
    return null;
  }

  // Rendered even with no products: the view owns the section shell and heading, and shows the "could
  // not load products" message under the heading so the visitor can tell which block failed.
  return <ProductGrid content={content} products={products} tileLayout={tileLayout} />;
}
